import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { Doalog } from '../../../interface/permanentdelegation/userdoa';
import { PermanentdelegationService } from '../../../services/PermanentDelegation/permanentdelegation.service';
import { DataService } from '../../../shared/data.service';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AppComponent } from '../../../app.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-logs',
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinner
  ],
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.css']
})
export class LogsComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['sno','catName', 'typeName', 'employeePreferredName', 'managerPreferrredName', 'previousAmount', 'newAmount', 'percentage', 'lastEditDate'];
  dataSource: MatTableDataSource<Doalog>;
  searchText: string = '';
  startDate: Date | null = null;
  endDate: Date | null = null;
  loggedUserEmail: string = '';
  isLoading:boolean = false;
  ExcelLoading: boolean = false;
  showFields: boolean = false;

  allData: Doalog[] = []; // Store all data here

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private dataService: DataService,
    private permanentDelegationService: PermanentdelegationService,
    private router: Router,
    private appComponent: AppComponent
  ) {
    this.dataSource = new MatTableDataSource<Doalog>([]);
    this.loggedUserEmail = this.appComponent.loggedUserEmail;
  }

  ngOnInit(): void {
    this.showFields = true;
    this.fetchLogs(); // Fetch logs on page load
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  fetchLogs(): void {
    this.isLoading = true;

    this.permanentDelegationService.getDOALogs(this.loggedUserEmail, null, null).subscribe(
      (data: Doalog[]) => {
        this.allData = data; 
        this.dataSource.data = data;
        this.isLoading = false;
        this.showFields = false;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  filterDataByDate(): void {
    if (this.startDate && this.endDate) {
      const start = new Date(this.startDate);
      const end = new Date(this.endDate);
      start.setHours(0, 0, 0, 0); 
      end.setHours(23, 59, 59, 999); 
      const filteredData = this.allData.filter(log => {
        const logDate = new Date(log.createdOn);
        return logDate >= start && logDate <= end;
      });
      this.dataSource.data = filteredData;
    } else {
      this.dataSource.data = this.allData; 
    }
}

  onDateChange(): void {
    this.filterDataByDate();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

   getPercentageClass(value: string): string {
    const percentage = parseFloat(value);
    return percentage >= 75 ? 'high-percentage' : 'normal-percentage';
  }

  getSerialNumber(index: number): number {
    return index + 1 + (this.paginator.pageIndex * this.paginator.pageSize);
  }

  downloadExcel(): void {
    this.isLoading = true;
    const currentData = this.dataSource.filteredData.map((log, index) => ({
      ...log,
      LogId: this.getSerialNumber(index),
    }));

    this.permanentDelegationService.getDOAlogsWorksheet(currentData).subscribe(
      (data: Blob) => {
        this.isLoading = false;
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `DOALogslist_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      error => {
        console.error('Error downloading the file', error);
      }
    );
  }
}
